import { Routing, Search } from "@common/_constants";
import { MessageService } from "@common/_services";
import LocalTime from "@common/components/Atoms/LocalTime";
import { Message as MessageModel, TileSize } from "@common/models";
import { DashboardTile } from "@pro/components/Organisms/DashboardTile";
import React, { Component } from "react";
import { Link } from "react-router-dom";

const DashboardTileMessagesNav = () => (
    <div className="c-dashboard__tile-nav">
        <Link
            to={`${Routing.Client.Pro.Messages.SEARCH}/?filter_type=${
                Search.MessageFilter.MY_UNREAD_MESSAGES
            }`}
            className="c-link no-underline">
            unread
        </Link>
        <Link to={Routing.Client.Pro.Messages.SEARCH} className="c-link no-underline">
            all
        </Link>
    </div>
);

interface MessagesProps {
    messageReadStates: any;
    onMarkReadStatus: (messageId: number, isRead: boolean) => void;
}
interface MessagesState {
    messages: {
        status: string;
        response: MessageModel[];
    };
}
export class Messages extends Component<MessagesProps, MessagesState> {
    private _abortControllers: { [key: string]: AbortController } = {};

    constructor(props) {
        super(props);
        this.state = {
            messages: {
                status: "pending",
                response: [] as MessageModel[],
            },
        };
    }

    componentDidMount() {
        // Check to see if there already was an abortController, and if so, call abort on it
        if (this._abortControllers.search) {
            this._abortControllers.search.abort();
        }
        this._abortControllers.search = new AbortController();
        const signal = this._abortControllers.search.signal;

        MessageService.search(
            {
                current_page: 1,
                page_size: 10,
                filter_type: Search.MessageFilter.MY_UNREAD_MESSAGES,
            },
            signal
        ).then(resp => {
            this.setState({ messages: { status: "success", response: resp.results } });
        });
    }

    componentWillUnmount() {
        const abortControllers = this._abortControllers;
        if (Object.keys(abortControllers).length > 0) {
            Object.keys(abortControllers).map(key => abortControllers[key].abort());
        }
    }

    render() {
        const { messages } = this.state;
        return (
            <DashboardTile
                title="messages"
                description={
                    messages.status === "success" && messages.response.length > 0
                        ? messages.response.length + " unread messages"
                        : "stay in touch"
                }
                size={TileSize.full}
                loading={messages.status === "pending"}
                nav={<DashboardTileMessagesNav />}>
                <div className="c-dashboard__messages">
                    {messages.status === "success" &&
                        messages.response.map((msg, index) => (
                            <div className="c-dashboard__block" key={index}>
                                <div className="c-dashboard__block-header">
                                    <div className="c-dashboard__block-title">
                                        <strong>{msg.from_name}</strong>
                                        {!msg.is_direct_message && (
                                            <Link
                                                className="c-link c-link--magenta"
                                                to={"/jobs/" + msg.context_job_id}>
                                                {msg.context_job_name}
                                            </Link>
                                        )}
                                        {msg.context_user_id &&
                                            !msg.is_direct_message && (
                                                <Link
                                                    className="c-link c-link--magenta"
                                                    to={`/referrals/${msg.context_user_id}/${
                                                        msg.context_job_id
                                                    }`}>
                                                    {msg.context_user_full_name}
                                                </Link>
                                            )}
                                    </div>
                                    <div className="c-dashboard__block-callout">
                                        {msg.sent_timestamp && (
                                            <LocalTime utcTimestamp={msg.sent_timestamp} />
                                        )}
                                        {!this.props.messageReadStates[msg.message_id] && (
                                            <a
                                                onClick={() => {
                                                    this.props.onMarkReadStatus(
                                                        msg.message_id,
                                                        true
                                                    );
                                                }}
                                                title="mark read">
                                                <br />
                                                mark as read
                                            </a>
                                        )}
                                    </div>
                                </div>
                                <div className="c-dashboard__block-body">
                                    {msg.subject && (
                                        <span className="c-message__subject">{msg.subject}</span>
                                    )}
                                    <span
                                        className="c-message__body"
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                msg.body.length > 500
                                                    ? msg.body.substring(0, 500) + "..."
                                                    : msg.body,
                                        }}
                                    />
                                </div>
                            </div>
                        ))}
                    {(!messages || !messages.response || messages.response.length === 0) && (
                        <div className="c-dashboard__blank">
                            <p className="u-text-gray">No new messages</p>
                        </div>
                    )}
                </div>
            </DashboardTile>
        );
    }
}
